var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NavPanelLink',{attrs:{"active":_vm.isActive,"activeLink":_vm.activeLink,"item":_vm.item,"panelExpanded":_vm.panelExpanded}},[(_vm.showGetStartedSticker && !_vm.isCustomer)?_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.panelExpanded),expression:"panelExpanded"}],class:_vm.$style.badge},[_vm._v(" get started ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }